import { CardContent } from 'bricks-ui/packages/bricks-ui';

export default CardContent;
